<template>
    <AppLayout title="Categorias">
        <div>
            <div class="categorias bg-white">
                <Toast />
                <Breadcrumb name="Categorias" routeName="categorias" page="Todas las categorias" />

                <DataTable
                    :value="categories"
                    responsiveLayout="scroll"
                    :paginator="true"
                    dataKey="id"
                    :filters="filters"
                    :rows="10"
                    :rowsPerPageOptions="[10, 20, 50]"
                >
                    <template #header>
                        <div
                            class="flex flex-col-reverse items-end lg:justify-between lg:flex-row"
                        >
                            <span class="block mt-2 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText
                                    placeholder="Buscar categoria..."
                                    v-model="filters['global'].value"
                                    class="p-inputtext-sm"
                                />
                            </span>
                            <Link href="/categorias/create">
                                <Button>
                                    <div class="flex items-center space-x-2">
                                        <Icon><Plus /></Icon>
                                        <span> Crear Categoria </span>
                                    </div>
                                </Button>
                            </Link>
                        </div>
                    </template>
                    <template #empty>
                        No hay categorias todavia
                    </template>
                    <Column header="Sucursal" v-if="$page.props.user.tipo !== 'sucursal_admin'">
                        <template #body="slotProps">
                            {{ sucursales[slotProps.data.sucursal_id] }}
                        </template> 
                    </Column>
                    <Column field="observacion" header="Descripción"></Column>
                    <Column field="alto" header="Alto(cm)"></Column>
                    <Column field="largo" header="Largo(cm)"></Column>
                    <Column field="ancho" header="Ancho(cm)"></Column>
                    <Column field="peso" header="Peso(kg)"></Column>
                    <Column field="precio" header="Precio(ARS)"></Column>
                    <Column header="Aciones">
                        <template #body="slotProps">
                            <div class="flex space-x-2">
                                <Link
                                    :href="
                                        '/categorias/' +
                                        slotProps.data.id +
                                        '/edit'
                                    "
                                >
                                    <Button>
                                        <Icon><PencilAlt /></Icon>
                                    </Button>
                                </Link>
                                <Button
                                    variant="destructive"
                                    @click="confirmDelete(slotProps.data.id)"
                                >
                                    <Icon><Trash /></Icon>
                                </Button>
                            </div>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
        <!-- Delete categoria dialog -->
        <Dialog
                v-model:visible="deleteCategoryDialog"
                :style="{ width: '450px' }"
                header="Confirmar"
                :modal="true"
            >
                <div class="flex items-center justify-center" style="height: 80px">
                    <i
                        class="pi pi-exclamation-triangle mr-3"
                        style="font-size: 2rem"
                    />
                    <span v-if="category">
                        ¿Seguro que deseas eliminar la categoria?
                    </span>
                </div>
                <template #footer>
                    <div class="flex justify-end space-x-2">
                        <Button @click="deleteCategoryDialog = false"
                            >Cancelar</Button
                        >
                        <Button variant="destructive" @click="deleteCategory"
                            >Eliminar</Button
                        >
                    </div>
                </template>
            </Dialog>
    </AppLayout>
</template>

<script>
import { FilterMatchMode } from "primevue/api";
import { Inertia } from "@inertiajs/inertia";
import AppLayout from "@/Layouts/AppLayout.vue";
import Breadcrumb from "@/shared/Breadcrumb.vue";
import Button from "@/shared/Button.vue";
import { Icon } from "@vicons/utils";
import { Plus, PencilAlt, Trash } from "@vicons/fa";
import { Link } from "@inertiajs/inertia-vue3";

export default {
    components: {
        AppLayout,
        Breadcrumb,
        Icon,
        Plus,
        Link,
        Button,
        PencilAlt,
        Trash,
    },
    props: {
        // propiedades inyectadas via laravel-inertia
        categorias: Array,
        sucursales: Object,
    },
    data() {
        return {
            deleteCategoryDialog: false,
            category: {},
            categories: [],
            isLoading: false,
            isEdit: false,
            filters: {},
        };
    },
    created() {
        this.categories = [...this.categorias];
        this.initFilters();
    },
    methods: {
        hideDialog() {
            this.categoryDialog = false;
            this.isLoading = false;
            this.isEdit = false;
        },
        reloadProps() {
            Inertia.reload({ only: ["categorias"] });
            this.categories = [...this.categorias];
        },
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            };
        },
        confirmDelete(category) {
            this.category = category;
            this.deleteCategoryDialog = true;
        },
        deleteCategory() {
            this.deleteCategoryDialog = false;
            this.$inertia.form().delete(`/categorias/${this.category}`, {
                onSuccess: () => {
                    this.$toast.add({
                        severity: "success",
                        summary: "Exito",
                        detail: "Categoria eliminada",
                        life: 3000,
                    });
                    this.reloadProps();
                },
                onError: (errors) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Ha ocurrido un error",
                        life: 3000,
                    });
                },
            });
        },
    },
};
</script>

<style>
.v-card-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
.v-danger-icon {
    color: #e30032;
}

.categorias .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.categorias .p-datatable-header {
    background: white;
    border-top: none;
}
.categorias .p-inputtext-sm {
    border-radius: 0.5rem;
}

.categorias .p-datatable-header {
    background: white;
    border-top: none;
}
.categorias .p-inputtext-sm {
    border-radius: 0.5rem;
}
.categorias .p-inputtext-sm:hover {
    border-color: #2e5f98;
}
.categorias .p-inputtext-sm:enabled:focus {
    border-color: #2e5f98;
    box-shadow: 0 0 0 1px #2e5f98;
}
.categorias .p-paginator .p-paginator-pages .p-paginator-page.p-highlight:focus {
    border-color: #2e5f98;
}
.categorias .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
    border-color: #2e5f98;
}

.categorias .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
    color: #2e5f98;
}
.categorias .p-link:focus {
    box-shadow: 0 0 0 1px #2e5f98;
}

.categorias .p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
    color: #2e5f98;
}

.categorias .p-dropdown:not(.p-disabled).p-focus {
    box-shadow: 0 0 0 1px #2e5f98;
    border-color: #2e5f98;
}

.categorias li.p-dropdown-item.p-highlight,
.p-dropdown-panel .p-dropdown-items .p-dropdown-item.p-highlight {
    color: #2e5f98;
}
</style>